export const SCRIPT_URL = {
  payments: 'https://x.klarnacdn.net/kp/lib/v1/api.js',
}

export const ENDPOINTS = {
  checkoutKlarnaSession: 'checkout/omnicredit/omnicredit-session',
  checkoutKlarnaError: 'checkout/omnicredit/omnicredit-error',
}

export const PAYMENTS_CONTAINER_PREFIX = 'klarna-payment-'
